import styled from "styled-components";

export const Container = styled.div`
    & .input-group-text {
        min-width: 90px;
        color: #74777A;
    }

    & .input-group button {
        border-color: #ced4da;
    }

    & .form-control[readonly] {
        background-color: #fff;
    }
`

export const FormHeaderRow = styled.div`
    display: flex;
`;

export const FormChecks = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
`

export const TabBody = styled.div`
    padding: 0px;
    border: 1px solid #74ace3;
`;

interface ICardDiagnosticProps {
    borderBottom?: boolean;
}

export const CardDiagnostic = styled.div<ICardDiagnosticProps>`
    padding: 5px 10px;
    border-bottom: ${props => props.borderBottom ? '1px solid #bbb' : 'none'};
`

export const TableDiagnostic = styled.table`
`;

export const TableBodyDiagnostic = styled.tbody`
`;

export const TableRowDiagnostic = styled.tr`
`;

interface ITableColumnDiagnosticProps {
    width?: string;
}

export const TableColumnDiagnostic = styled.td<ITableColumnDiagnosticProps>`
    width: ${props => props.width || 'auto'};
`;